export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1100px] mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl md:rounded-3xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Artfully%20arranged%20fashion%20essentials%20flatlay%20with%20beige%20sneakers%20linen%20shirt%20gold%20accessories%20and%20leather%20notebook%20on%20soft%20warm%20sand%20colored%20textured%20surface%2C%20minimalist%20editorial%20photography%2C%20soft%20natural%20side%20light%20with%20gentle%20shadows%2C%20elegant%20European%20lifestyle%20aesthetic%2C%20carefully%20styled%20negative%20space%20for%20text%20overlay%2C%20warm%20inviting%20neutral%20tones%2C%20premium%20catalog%20composition&width=1400&height=600&seq=cta-banner-v2&orientation=landscape"
            alt="OOPBuy Spreadsheet"
            className="w-full h-[300px] md:h-[420px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent"></div>

          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 md:px-8">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 max-w-2xl">
              Bereit für deinen nächsten <span className="italic font-normal">Lieblingsfund</span>?
            </h2>
            <p className="text-sm md:text-base text-white/80 max-w-lg mb-8 leading-relaxed">
              Entdecke das OOPBuy Spreadsheet und finde die besten Produkte &ndash; schneller, sicherer und günstiger als je zuvor.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold rounded-full bg-white text-foreground-900 hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                OOPBuy Spreadsheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Buy it now
                <i className="ri-shopping-cart-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}